export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'InterniDilna';
export const NAME = 'InterniDilenska';
